export const DISPLAY_EXPRESS_CHECKOUT = 'DISPLAY_EXPRESS_CHECKOUT';
export const EXPRESS_CHECKOUT_ADDRESS = 'EXPRESS_CHECKOUT_ADDRESS';
export const EXPRESS_CHECKOUT_PAYMENT = 'EXPRESS_CHECKOUT_PAYMENT';
export const TOGGLE_EXPRESS_CHECKOUT = 'TOGGLE_EXPRESS_CHECKOUT';
